import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { transactionsTabs } from '@features/transactions/constants';
import { TabPill } from 'types/tabs';

interface BranchState {
  currentBranchFilter: {
    branchId: string;
    branchName: string;
    imageUrl?: string;
  };
  currentTransaction: {
    filter: TabPill;
  };
}
const initialState: BranchState = {
  currentBranchFilter: {
    branchId: '',
    branchName: '',
    imageUrl: ''
  },
  currentTransaction: {
    filter: transactionsTabs[0]
  }
};

export const branchSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    updateBranchFilter: (
      state,
      action: PayloadAction<{
        branchId: string;
        branchName: string;
        imageUrl?: string;
      }>
    ) => {
      state.currentBranchFilter = action.payload;
    },
    updateTransactionFilter: (
      state,
      action: PayloadAction<{ filter: TabPill }>
    ) => {
      state.currentTransaction = action.payload;
    },
    resetBranchState: () => initialState
  }
});

export const { updateBranchFilter, updateTransactionFilter, resetBranchState } =
  branchSlice.actions;
export default branchSlice.reducer;
